<template>
    <div id="resouces" class="offset">
        <div class="fixed-background">
            <div class="row dark text-center">
                <div class="col-md-12">
                    <h3 class="heading">MIÉRT VÁLASSZON MINKET?</h3>
                    <div class="heading-underline"></div>
                </div>
                <div class="col-md-4">
                    <h3>Bizonyítékokon alapuló fogorvoslás
                    </h3>
                    <div class="feature">
                        <i class="fas fas fa-star fa-3x"></i>
                    </div>
                    <p class="lead">A fogászati ellátást nem lehet kizárólag a fogorvos egyéni tapasztalatára építeni, hanem elengedhetetlen a folyamatos tanulás és a rendelkezésre álló legfrisseb fogászati kutatások naprakész ismerete.
</p>
                </div>
                <div class="col-md-4">
                    <h3>Teljeskörű tájékoztatás</h3>
                    <div class="feature">
                        <i class="fas fa-smile fa-3x"></i>
                    </div>
                    <p class="lead">Röntgenfelvételek és -ha szükséges- arc- és szájüregi fotók, valamint lenyomatok alapján komplex kezelési tervet készítünk és mindenre kiterjedő, részletes tájékoztatást nyújtunk a lehetséges fogorvosi kezelések menetére, árára vonatkozóan.</p>
                </div>
                <div class="col-md-4">
                    <h3>bizonyítékokon alapuló fogorvoslás</h3>
                    <div class="feature">
                        <i class="fas fa-syringe fa-3x"></i>
                    </div>
                    <p class="lead">A fogászati ellátást nem lehet kizárólag a fogorvos egyéni tapasztalatára építeni, hanem elengedhetetlen a folyamatos tanulás és a rendelkezésre álló legfrisseb fogászati kutatások naprakész ismerete.</p>
                </div>
            </div>
            <div class="overlay"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: "resouces"
};
</script>
<style scoped>
#resouces:before {
    display: block;
    content: "";
    height: 3.6rem;
    margin-top: -3.6rem;
}
.fixed-background {
    position: relative;
    background-image: url("../assets/images/bg2.jpg");
    background-attachment: fixed;
    background-size: cover;
    background-repeat: no-repeat;
}
.dark{
    background-color: rgba(0, 0, 0, 0.75);
    color: white; 
    padding: 7rem 2rem;
}
.fixed-background h3 {
}

.fixed-background p {
}
</style>
